module.exports = __webpack_public_path__ + "d82e1e81e2f80c32e689e78121baf8f6.svg";